import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* LIST + SEARCH */

export const listBuyersByParams = (data)=>{
return api.post(ENDPOINTS.BUYERS.SEARCH,data);
};

/* DETAILS */

export const getBuyerById = (id)=>{
return api.get(ENDPOINTS.BUYERS.BY_ID(id));
};

/* VERIFY */

export const verifyBuyer = (id)=>{
return api.put(ENDPOINTS.BUYERS.VERIFY(id));
};

/* UNVERIFY */

export const unverifyBuyer = (id)=>{
return api.put(ENDPOINTS.BUYERS.UNVERIFY(id));
};

/* ACTIVATE */

export const activateBuyer = (id)=>{
return api.put(ENDPOINTS.BUYERS.ACTIVATE(id));
};

/* DEACTIVATE */

export const deactivateBuyer = (id)=>{
return api.put(ENDPOINTS.BUYERS.DEACTIVATE(id));
};